import React, { FC, useEffect, useState } from "react";
import ExpandMoreIcon from "../assets/svg/expand-more-icon.svg";
import CollapseIcon from "../assets/svg/collapse-icon.svg";
import svgIcons from "../assets/svg/svgIcons";

interface AccordianProps {
  title: string | React.ReactNode;
  children: React.ReactNode;
  collapsible?: boolean;
  hasDetailsPage?: boolean;
  isMultiClick?: boolean;
  handleClass?: string;
  contentClass?: string;
  buttonSpacingClass?: string;
  wrapperClass?: string;
  wrapperBorderClass?: string;

  isOpen: boolean;
  onClick: () => void;
}

const AccordianControlled: FC<AccordianProps> = ({
  title,
  children,
  collapsible = true,
  hasDetailsPage = true,
  isMultiClick = false,
  handleClass = "",
  contentClass = "",
  buttonSpacingClass = "py-[10px]",
  wrapperClass = "",
  wrapperBorderClass = "border-b border-gray-200",

  isOpen,
  onClick,
}) => {

  return (
    <div className={`${wrapperClass} ${hasDetailsPage ? `${wrapperBorderClass} last-of-type:border-b-0` : ""}`}>
      {typeof title === 'string' ? (
        <button type="button"
          className={`w-full ${hasDetailsPage ? "px-5" : ""} ${buttonSpacingClass} flex items-center${collapsible ? " cursor-pointer" : ''} ${handleClass}`}
          {...(collapsible && !isMultiClick ? {
            onClick: () => {
              onClick();
            }
          } : {})}
        >
          <div className="flex-grow text-left text-lg font-semibold leading-10 tracking-tighter text-accent-blue-dark">{title}</div>
          {collapsible && (<img src={isOpen ? svgIcons.CollapseIcon : svgIcons.ExpandMoreIcon} alt="expand-more-icon" onClick={() => isMultiClick ? onClick() : {}} />)}
        </button>
      ) : (
        <div
          className={`w-full ${hasDetailsPage ? "px-5" : ""} py-[10px] flex items-center${collapsible ? " Xcursor-pointer" : ''} ${handleClass}`}
          {...(collapsible && !isMultiClick ? { onClick: () => onClick() } : {})}
        >
          <div className="flex-grow text-left text-lg font-semibold leading-10 tracking-tighter text-accent-blue-dark">{title}</div>
          {collapsible && (
            <button
              type="button"
              onClick={() => isMultiClick ? onClick() : {}}
            >
              <img
                src={isOpen ? svgIcons.CollapseIcon : svgIcons.ExpandMoreIcon}
                alt="expand-more-icon"
              />
            </button>
          )}
        </div>
      )}
      {isOpen && <div className={contentClass}>{children}</div>}
    </div>
  )
}

export default AccordianControlled;